import { IDashboardWidgetCatalogItem } from '../../../types/IDashboardWidgetCatalogItem';
import { EventsOverTimeWidgetConfiguration } from './EventsOverTimeWidgetConfiguration';
import { DashboardWidgetType } from '@/modules/dashboards/types/DashboardWidgetType';
import { v4 } from 'uuid';
import { BarChartRounded } from '@mui/icons-material';
import { TFunction } from 'i18next';
import { DashboardWidgetCatalogItemImageColorType } from '../../widget-catalog/DashboardWidgetCatalogItemImage';
import { Layout } from 'react-grid-layout';

export class EventsOverTimeWidgetCatalogItem implements IDashboardWidgetCatalogItem<EventsOverTimeWidgetConfiguration> {
  title: string;
  description: string;
  icon: JSX.Element;
  iconColor: DashboardWidgetCatalogItemImageColorType;
  id: string;
  type: DashboardWidgetType;
  configuration: EventsOverTimeWidgetConfiguration;
  layout: Layout;

  constructor(t: TFunction) {
    this.title = t('dashboard.eventsOverTimeWidget.title');
    this.description = t('dashboard.eventsOverTimeWidget.description');
    this.icon = <BarChartRounded />;
    this.iconColor = 'green';
    this.id = v4();
    this.type = DashboardWidgetType.EventsOverTimeWidget;
    this.configuration = new EventsOverTimeWidgetConfiguration(t);
    this.layout = {
      h: 2,
      w: 3,
      i: v4(),
      x: 0,
      y: 0,
      maxH: 2,
      maxW: 4,
      minH: 2,
      minW: 2,
    };
  }
}
